/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { Link as RouterLink } from "react-router-dom";
// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import studyMaterials from "../../../assets/images/study.svg";
import webinar from "../../../assets/images/webinars.svg";
import grievance from "../../../assets/images/grievance.svg";
import payment from "../../../assets/images/payment.svg";
// Material Kit 2 React components
// import MKBox from "components/MKBox";

const CourseCard = styled("div")({
  textAlign: "center",
  justifyContent: "center",
  width: "100%",
  fontSize: 16,
  color: "#0A0A0A",
  display: "flex",
});
// const SectionCard = styled("div")({
//   // boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.2);",
//   minHeight: "200px",
//   display: "flex",
//   alignItems: "center",
//   paddingTop: "40px",
//   textAlign: "center",
// });

function Information() {
  return (
    <Container sx={{ mt: 1, mb: 1, mx: 5 }}>
      <Grid container spacing={3} alignItems="center" justifyContent="center">
        <Grid item xs={10} lg={3} mb={3} sx={{ mx: "auto", pointer: "cursor" }}>
          <div className=" category-card">
            <br />

            <div className="row ">
              <div className="col-md-12">
                <div className="row pb-3">
                  <div className="card-custom ">
                    <img
                      src={studyMaterials}
                      alt={studyMaterials}
                      width="80"
                      className="img-fluid cust-img text-center"
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                {localStorage.getItem("token") ? (
                  <RouterLink to="/e-learning-and-question-papers">
                    <CourseCard>
                      <h1 className="category-head">STUDY MATERIALS</h1>
                    </CourseCard>
                  </RouterLink>
                ) : (
                  <RouterLink to="/student/sign-in">
                    <CourseCard>
                      <h1 className="category-head">STUDY MATERIALS</h1>
                    </CourseCard>
                  </RouterLink>
                )}
              </div>
            </div>
          </div>
        </Grid>

        <Grid item xs={10} lg={3} mb={3} sx={{ mx: "auto", pointer: "cursor" }}>
          <RouterLink to="/webinars">
            <div className="category-card">
              <div className="row">
                <div className="col-md-12">
                  <div className="row pb-3">
                    <div className="card-custom">
                      <img
                        src={webinar}
                        alt={webinar}
                        width="80"
                        className="img-fluid cust-img text-center"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <CourseCard>
                    <h1 className="category-head">WEBINARS</h1>
                  </CourseCard>
                </div>
              </div>
            </div>
          </RouterLink>
        </Grid>

        <Grid item xs={10} lg={3} mb={3} sx={{ mx: "auto", pointer: "cursor" }}>
          <RouterLink to="/grievance">
            <div className="category-card">
              <div className="row">
                <div className="col-md-12">
                  <div className="row pb-3">
                    <div className="card-custom">
                      <img
                        src={grievance}
                        alt={grievance}
                        width="80"
                        className="img-fluid cust-img text-center"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <CourseCard>
                    <h1 className="category-head">grievance redressal</h1>
                  </CourseCard>
                </div>
              </div>
            </div>
          </RouterLink>
        </Grid>
        <Grid item xs={10} lg={3} mb={3} sx={{ mx: "auto", pointer: "cursor" }}>
          <a href="https://forms.eduqfix.com/snlawclg/add" rel="noreferrer" target="_blank">
            <div className="category-card">
              <div className="row">
                <div className="col-md-12">
                  <div className="row pb-3">
                    <div className="card-custom">
                      <img
                        src={payment}
                        alt={payment}
                        width="80"
                        className="img-fluid cust-img text-center"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <CourseCard>
                    <h1 className="category-head">online payment</h1>
                  </CourseCard>
                </div>
              </div>
            </div>
          </a>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Information;
